import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    locales: ['en', 'fr', 'es', 'pt'],
    defaultLocale: 'en',
    pathnames: {
        '/': '/',
        '/tv-rights-buyers': {
            fr: '/acheteurs-droits-tv',
            es: '/compradores-derechos-tv',
            pt: '/compradores-direitos-tv',
        },
        '/tv-rights-sellers': {
            fr: '/vendeurs-droits-tv',
            es: '/vendedores-derechos-tv',
            pt: '/vendedores-direitos-tv',
        },
        '/programs': {
            fr: '/programmes',
            es: '/programas',
            pt: '/programas',
        },
        '/programs/dashboard': {
            fr: '/programmes/dashboard',
            es: '/programas/dashboard',
            pt: '/programas/dashboard',
        },
        '/programs/[id]': {
            fr: '/programmes/[id]',
            es: '/programas/[id]',
            pt: '/programas/[id]',
        },
        '/settings': {
            fr: '/parametres',
            es: '/ajustes',
            pt: '/configuracoes',
        },
        '/licenses': {
            fr: '/licenses',
            es: '/licenses',
            pt: '/licenses',
        },
        '/credits': {
            fr: '/credits',
            es: '/credits',
            pt: '/credits',
        },
        '/transactions': {
            fr: '/transactions',
            es: '/actas',
            pt: '/transações',
        },
        '/cart': {
            fr: '/panier',
            es: '/carrito',
            pt: '/carrinho',
        },
        '/cart/confirmation-page/[id]': {
            fr: '/panier/page-de-confirmation/[id]',
            es: '/carrito/pagina-de-confirmacion/[id]',
            pt: '/carrinho/pagina-de-confirmacao/[id]',
        },
        '/marketing': {
            fr: '/marketing',
            es: '/marketing',
            pt: '/marketing',
        },
        '/formats': {
            fr: '/formats',
            es: '/formats',
            pt: '/formats',
        },
        '/formats/[id]': {
            fr: '/formats/[id]',
            es: '/formats/[id]',
            pt: '/formats/[id]',
        },
    },
});
